<template>
  <v-card rounded="0" elevation="0" color="primary" style="display: flex; flex-direction: column; min-height: 100vh; height: 100vh; max-height: 100vh">
    <v-card rounded="0" elevation="0" color="primary" style="flex: 1; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
      <template v-if="!loader.setup">
        <CRMDashboardCurrentCRMWhatsappConversationsComponent v-if="navigation.CRMDashboardTab == 'currentCRMWhatsappConversations'" />
        <CRMDashboardCRMAgentSummaryComponent v-if="navigation.CRMDashboardTab == 'CRMAgentSummary'" />
        <CRMDashboardCRMLocalitySummaryComponent v-if="navigation.CRMDashboardTab == 'CRMLocalitySummary'" />
        <CRMDashboardCRMRealTimeEventsComponent v-if="navigation.CRMDashboardTab == 'events'" />
        <CRMDashboardCRMWhatsappConversationFeedbacksComponent v-if="navigation.CRMDashboardTab == 'CRMWhatsappConversationFeedbacks'" /> 
      </template>
    </v-card>

    <v-card color="primary" elevation="0" rounded="0" style="width: 100%;">
      <template v-if="!loader.setup">
        <v-tabs v-model="navigation.CRMDashboardTab" @update:model-value="parseURL(navigation.CRMDashboardTab)" density="compact" grow>
          <v-tab 
            v-for="CRMDashboardTab in navigation.CRMDashboardTabs" 
            :key="CRMDashboardTab.value" 
            :value="CRMDashboardTab.value"
            :class="navigation.CRMDashboardTab == CRMDashboardTab.value ? 'selectedVListItem' : null"
            class="hoverableText"
          >
            <v-icon :size="navigation.CRMDashboardTab == CRMDashboardTab.value ? 'large' : 'medium'" style="margin-right: 10px;">{{ CRMDashboardTab.icon }}</v-icon>
            <p :style="navigation.CRMDashboardTab == CRMDashboardTab.value ? 'font-weight: bold;' : null" style="font-size: medium;">{{ CRMDashboardTab.title }}{{ CRMDashboardTab.value == 'CRMDashboardCRMWhatsappConversationFeedbacks' ? ` (${display.CRMWhatsappConversationFeedbackCount})` : '' }}</p>
          </v-tab>
        </v-tabs>
      </template>
    </v-card>
  </v-card>
</template>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import websocket from '@/utilities/websocket';
  import CRMDashboardCurrentCRMWhatsappConversationsComponent from './CRMDashboardCurrentCRMWhatsappConversationsComponent.vue';
  import CRMDashboardCRMAgentSummaryComponent from './CRMDashboardCRMAgentSummaryComponent.vue';
  import CRMDashboardCRMLocalitySummaryComponent from './CRMDashboardCRMLocalitySummaryComponent.vue';
  import CRMDashboardCRMRealTimeEventsComponent from './CRMDashboardCRMRealTimeEventsComponent.vue';
  import CRMDashboardCRMWhatsappConversationFeedbacksComponent from './CRMDashboardCRMWhatsappConversationFeedbacksComponent.vue';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: 
    {
      CRMDashboardCurrentCRMWhatsappConversationsComponent,
      CRMDashboardCRMLocalitySummaryComponent,
      CRMDashboardCRMAgentSummaryComponent,
      CRMDashboardCRMRealTimeEventsComponent,
      CRMDashboardCRMWhatsappConversationFeedbacksComponent
    },
    data: () => ({
      display: 
      {
        CRMWhatsappConversationFeedbackCount: 0
      },
      navigation: 
      {
        CRMDashboardTab: 'currentCRMWhatsappConversations',
        CRMDashboardTabs: []
      },
      loader:
      {
        setup: false
      },
      websocketCallback:
      {
        closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog: null,
        generateCRMWhatsappInvoice: null,
        cancelCRMWhatsappInvoice: null,
        confirmSINPEPaymentForCRMWhatsappConversation: null,
        confirmSINPEPaymentForCRMWhatsappInvoice: null
      },
      systemInformationData:
      {
        CRMAccountID: null,
        CRMAgent: null,
        updateSubscription: null
      }
    }),
    
    methods: 
    {
      async handleWebsocket(){
        websocket.connectWebsocket();
        this.websocketCallback.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog = async (websocketMessageData) => {
          if (websocketMessageData.websocketMessageContent.CRMAgentID != this.systemInformationData.CRMAgent.CRMAgentID) {
            if(!this.systemInformationData.CRMWhatsappMessageNotificationDisabled) this.$root.notificationDialog.showCRMRealTimeEvent(Math.random().toString(36).substring(2, 15), 'closeCRMWhatsappConversation', websocketMessageData.websocketMessageContent);
          }
        };
        this.websocketCallback.generateCRMWhatsappInvoice = async (websocketMessageData) => {
          if (websocketMessageData.websocketMessageContent.CRMAgentID != this.systemInformationData.CRMAgent.CRMAgentID) {
            if(!this.systemInformationData.CRMWhatsappMessageNotificationDisabled) this.$root.notificationDialog.showCRMRealTimeEvent(Math.random().toString(36).substring(2, 15), 'generateCRMWhatsappInvoice', websocketMessageData.websocketMessageContent);
          }
        };
        this.websocketCallback.cancelCRMWhatsappInvoice = async (websocketMessageData) => {
          if (websocketMessageData.websocketMessageContent.CRMAgentID != this.systemInformationData.CRMAgent.CRMAgentID) {
            if(!this.systemInformationData.CRMWhatsappMessageNotificationDisabled) this.$root.notificationDialog.showCRMRealTimeEvent(Math.random().toString(36).substring(2, 15), 'cancelCRMWhatsappInvoice', websocketMessageData.websocketMessageContent);
          }
        };
        this.websocketCallback.confirmSINPEPaymentForCRMWhatsappConversation = async (websocketMessageData) => {
          if (websocketMessageData.websocketMessageContent.CRMAgentID != this.systemInformationData.CRMAgent.CRMAgentID) {
            if(!this.systemInformationData.CRMWhatsappMessageNotificationDisabled) this.$root.notificationDialog.showCRMRealTimeEvent(Math.random().toString(36).substring(2, 15), 'confirmSINPEPayment', websocketMessageData.websocketMessageContent);
          }
        };
        this.websocketCallback.confirmSINPEPaymentForCRMWhatsappInvoice = async (websocketMessageData) => {
          if (websocketMessageData.websocketMessageContent.CRMAgentID != this.systemInformationData.CRMAgent.CRMAgentID) {
            if(!this.systemInformationData.CRMWhatsappMessageNotificationDisabled) this.$root.notificationDialog.showCRMRealTimeEvent(Math.random().toString(36).substring(2, 15), 'confirmSINPEPayment', websocketMessageData.websocketMessageContent);
          }
        };
        websocket.addWebsocketMessageListener('/CRMWhatsappConversation/functions/closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog', this.websocketCallback.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog);
        websocket.addWebsocketMessageListener('/CRMWhatsappInvoice/functions/generateCRMWhatsappInvoice', this.websocketCallback.generateCRMWhatsappInvoice);
        websocket.addWebsocketMessageListener('/CRMWhatsappInvoice/functions/cancelCRMWhatsappInvoice', this.websocketCallback.cancelCRMWhatsappInvoice);
        websocket.addWebsocketMessageListener('/SINPEPayment/functions/confirmSINPEPaymentForCRMWhatsappConversation', this.websocketCallback.confirmSINPEPaymentForCRMWhatsappConversation);
        websocket.addWebsocketMessageListener('/SINPEPayment/functions/confirmSINPEPaymentForCRMWhatsappInvoice', this.websocketCallback.confirmSINPEPaymentForCRMWhatsappInvoice);
      },

      disconnectWebsocket(){
        if (this.websocketCallback.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog) websocket.removeWebsocketMessageListener('/CRMWhatsappConversation/functions/closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog', this.websocketCallback.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog);
        if (this.websocketCallback.generateCRMWhatsappInvoice) websocket.removeWebsocketMessageListener('/CRMWhatsappInvoice/functions/generateCRMWhatsappInvoice', this.websocketCallback.generateCRMWhatsappInvoice);
        if (this.websocketCallback.cancelCRMWhatsappInvoice) websocket.removeWebsocketMessageListener('/CRMWhatsappInvoice/functions/cancelCRMWhatsappInvoice', this.websocketCallback.cancelCRMWhatsappInvoice);
        if (this.websocketCallback.confirmSINPEPaymentForCRMWhatsappConversation) websocket.removeWebsocketMessageListener('/SINPEPayment/functions/confirmSINPEPaymentForCRMWhatsappConversation', this.websocketCallback.confirmSINPEPaymentForCRMWhatsappConversation);
        if (this.websocketCallback.confirmSINPEPaymentForCRMWhatsappInvoice) websocket.removeWebsocketMessageListener('/SINPEPayment/functions/confirmSINPEPaymentForCRMWhatsappInvoice', this.websocketCallback.confirmSINPEPaymentForCRMWhatsappInvoice);
        this.websocketCallback.closeCRMWhatsappConversationFromCloseCRMWhatsappConversationDialog = null;
        this.websocketCallback.generateCRMWhatsappInvoice = null;
        this.websocketCallback.cancelCRMWhatsappInvoice = null;
        this.websocketCallback.confirmSINPEPaymentForCRMWhatsappConversation = null;
        this.websocketCallback.confirmSINPEPaymentForCRMWhatsappInvoice = null;
      },

      async parseURL(CRMDashboardTab) {
        if (!CRMDashboardTab) {
          const url = this.$route.fullPath;
          const urlParts = url.split('/CRMDashboard');
          let lastPart = urlParts[urlParts.length - 1];

          if (!lastPart || lastPart == '') {
            lastPart = 'currentCRMWhatsappConversations';
            this.navigation.CRMDashboardTab = lastPart;
            this.$generalFunctions.default.navigateTo(`/CRMDashboard/${lastPart}`);
          } else if (!lastPart.startsWith('CRMDashboard')) {
            this.navigation.CRMDashboardTab = lastPart.replace('/', '');
            this.$generalFunctions.default.navigateTo(`/CRMDashboard${lastPart}`);
          }
        } else {
          let tabValue = CRMDashboardTab;
          this.navigation.CRMDashboardTab = tabValue;
          this.$generalFunctions.default.navigateTo(`/CRMDashboard/${tabValue}`);
        }
      },

      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.CRMWhatsappMessageNotificationDisabled = updatedSystemInformationData.CRMWhatsappMessageNotificationDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },

    async mounted() {
      this.loader.setup = true;
      await this.getSystemInformationData();
      const hide = this.systemInformationData.CRMAgent?.CRMAgentPermissions.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMDashboard/onlyCRMShippingAgent')?.CRMAgentPermissionValue == '1';

      if (hide == false) await this.handleWebsocket();
      await this.parseURL(null);
      this.loader.setup = false;

      if (this.systemInformationData.CRMAgent?.CRMAgentPermissions.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMDashboard/onlyCRMShippingAgent')?.CRMAgentPermissionValue == '1'){
        this.navigation.CRMDashboardTabs = [{value: 'CRMLocalitySummary', title: 'LOCALIDADES', icon: 'mdi-store'}];
      } else {
        this.navigation.CRMDashboardTabs = 
        [
          {value: 'currentCRMWhatsappConversations', title: 'CONVERSACIONES', icon: 'mdi-chat'}, 
          ...(this.systemInformationData.CRMAgent?.CRMAgentPermissions.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMDashboard/allAccess')?.CRMAgentPermissionValue == '1' ? [{value: 'CRMAgentSummary', title: 'AGENTES', icon: 'mdi-briefcase-account'}] : []),
          ...(this.systemInformationData.CRMAgent?.CRMAgentPermissions.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMDashboard/allAccess')?.CRMAgentPermissionValue == '1' ? [{value: 'CRMLocalitySummary', title: 'LOCALIDADES', icon: 'mdi-store'}] : []),
          {value: 'events', title: 'EVENTOS', icon: 'mdi-bell'}, 
          {value: 'CRMWhatsappConversationFeedbacks', title: 'FEEDBACKS', icon: 'mdi-comment'}
        ];
      }
    },

    beforeUnmount() {
      this.disconnectWebsocket();
      if (this.systemInformationData.updateSubscription) systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
      this.systemInformationData.updateSubscription = null;
    }
  }
</script>